// extracted by mini-css-extract-plugin
export var checkIcon = "_9-2";
export var heading = "_9-1";
export var panel = "_9-0";